import PropTypes from 'prop-types'

import DashboardCard from '../DashboardCard'
import DashboardCardHeader from '../DashboardCardHeader'

import ScoreGrade from './ScoreGrade'
import BuildYourScoreSection from './BuildYourScoreSection'

import theme from 'theme'
import Text from 'components/common/Text'
import Button from 'components/common/Button'

export function CardRow({ title, textLabel, buttonProps, ...rest }) {
  const { as: buttonAs, label: buttonLabel, ...otherButtonProps } = buttonProps

  return (
    <div {...rest}>
      <div>
        <CardTitle>{title}</CardTitle>
        <CardText>{textLabel}</CardText>
      </div>
      <Button as={buttonAs} {...otherButtonProps}>
        {buttonLabel}
      </Button>
    </div>
  )
}

CardRow.propTypes = {
  title: PropTypes.string,
  textLabel: PropTypes.string,
  buttonProps: PropTypes.object
}

export function CardTitle({ children, ...rest }) {
  return (
    <Text
      as="h4"
      css={{
        color: theme.colors.steel[2],
        fontSize: theme.fontSizes[1]
      }}
      {...rest}
    >
      {children}
    </Text>
  )
}

CardTitle.propTypes = {
  children: PropTypes.node
}

export function CardText({ children, ...rest }) {
  return (
    <Text
      as="small"
      css={{
        color: theme.colors.steel[1],
        fontWeight: theme.fontWeights[1],
        fontSize: theme.fontSizes[0]
      }}
      {...rest}
    >
      {children}
    </Text>
  )
}

CardText.propTypes = {
  children: PropTypes.node
}

export function CardMainTitle({ children, ...rest }) {
  return (
    <Text
      as="h6"
      css={{
        letterSpacing: theme.letterSpacing[4],
        color: theme.colors.steel[1]
      }}
      {...rest}
    >
      {children}
    </Text>
  )
}

CardMainTitle.propTypes = {
  children: PropTypes.node
}

export default function ReliabilityScoreCard() {
  return (
    <DashboardCard
      headerContent={
        <DashboardCardHeader hideFilter title="Your Team’s Reliability Score" />
      }
      height="auto"
      showHoverEffect={false}
    >
      <div
        css={{
          paddingTop: theme.space[4],
          paddingBottom: theme.space[4],
          paddingRight: theme.space[5],
          paddingLeft: theme.space[5],
          display: 'grid',
          gridTemplateColumns: 'repeat(2, auto)',
          gap: theme.space[7],
          alignItems: 'center'
        }}
      >
        <ScoreGrade />
        <BuildYourScoreSection />
      </div>
    </DashboardCard>
  )
}
